import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function EvidenceHelp({ theme, ...props }) {
  return (
    <svg
      width="26"
      height="28"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(theme.container, theme[props.svg], props.className)}
    >
      <g fill="none" fillRule="evenodd">
        <g
          transform="translate(1.074 1.037)"
          strokeLinecap="round"
          className={theme.stroke}
          strokeLinejoin="round"
        >
          <circle
            stroke="#4A4A4A"
            strokeWidth="2"
            fill="#FFF"
            cx="9.748"
            cy="10.267"
            r="9.333"
          />
          <path
            d="M16.281 17.733l7.052 7.26"
            stroke="#4A4A4A"
            strokeWidth="2.4"
          />
          <path
            d="M10.889 4.978c2.489.518 4.355 2.696 4.355 5.289 0 1.037-.31 1.97-.725 2.8"
            stroke="#FA0"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  )
}

EvidenceHelp.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
